<!-- <div class="d-flex flex-column">
  <span>Segundos: {{seconds}}</span>
  <span>Tiempo estimado:{{estimate}}</span>
  <span>Porcentaje:{{percent}}</span>
</div>
 -->
<span [ngSwitch]="type">
  <div *ngSwitchCase="1">
    <app-loading-type-1
      [view]="view"
      [seconds]="seconds"
      [estimate]="estimate"
      [percent]="percent"
    ></app-loading-type-1>
  </div>
  <div *ngSwitchCase="2">
    <app-loading-type-2
      [view]="view"
      [seconds]="seconds"
      [estimate]="estimate"
      [percent]="percent"
    ></app-loading-type-2>
  </div>
  <p *ngSwitchDefault></p>
</span>
